import React, { useState, useEffect } from "react";
import Title from "../components/Title";
import Button from "../components/Button";
import Card from "../components/Card";
import Input from "../components/Input";
import Navbar from "../components/Navbar";
import { apiUrl } from "../utils/api";
import { calculateShiftSalaryTotal } from "../utils/salary";
import {
  createLocalDateFromInputValue,
  formatInputDateToJapanese,
  getJstCurrentMonthInputValue,
  getJstTodayInputValue,
} from "../utils/jst";

function StaffShift({ setPage }) {
  const [date, setDate] = useState(getJstTodayInputValue());
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [shifts, setShifts] = useState([]);
  const [editId, setEditId] = useState(null);
  const [shiftMonth, setShiftMonth] = useState(getJstCurrentMonthInputValue);
  const visibleShifts = shifts
    .filter((shift) => String(shift.date).slice(0, 7) === shiftMonth)
    .sort((a, b) => createLocalDateFromInputValue(a.date) - createLocalDateFromInputValue(b.date));
  const approvedShifts = visibleShifts.filter((shift) => shift.status === "approved");
  const pendingShifts = visibleShifts.filter((shift) => shift.status !== "approved");

  // シフト取得
  const fetchShifts = async () => {
    const token = localStorage.getItem("token");
	    const res = await fetch(
	      apiUrl("/shifts"),
      { headers: {Authorization:`Bearer ${token}`,},}
    );
    const data = await res.json();
    setShifts(data);
  };

  // 初回取得
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      window.location.href = "/";
      return;
    }
    fetchShifts();
  }, []);

  // シフト追加
  const handleSubmit = async () => {
    const token = localStorage.getItem("token");
	    await fetch(
	      apiUrl("/shifts"),
      {
        method: "POST",
        headers: {"Content-Type":"application/json",Authorization:`Bearer ${token}`,},
        body: JSON.stringify({
          date,
          startTime,
          endTime,
        }),
      }
    );
    fetchShifts();
    setDate("");
    setStartTime("");
    setEndTime("");
  };

  // 削除
  const handleDelete = async (id) => {

    const token =
      localStorage.getItem("token");

	    const res = await fetch(
	      apiUrl(`/shifts/${id}`),
      {
        method: "DELETE",
        headers: { Authorization:`Bearer ${token}`,},
      }
    );

    // エラー
    if (!res.ok) {
      const data = await res.json();
      alert(data.message);
      return;
    }
    fetchShifts();
  };
  // 更新
  const handleUpdate = async (shift) => {

    const token =
      localStorage.getItem("token");

	    const res = await fetch(
	      apiUrl(`/shifts/${shift.id}`),
      {
        method: "PUT",
        headers: {
          "Content-Type":"application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          date: shift.date,
          startTime: shift.start_time,
          endTime: shift.end_time,
        }),
      }
    );
    // エラー
    if (!res.ok) {
      const data = await res.json();
      alert(data.message);
      return;
    }
    setEditId(null);
    fetchShifts();
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  //給与計算
  const calculateSalary = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return 0;
    return calculateShiftSalaryTotal({
      shifts,
      hourlyWage: user.hourlyWage,
      transportationFee: user.transportationFee,
    });
  };

// =========================
// 表示
// =========================
	  return (
	    <div>
	      <Navbar />
	      <main className="page-shell" style={{ maxWidth: "1040px", }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: "16px", alignItems: "center", flexWrap: "wrap", }}>
        <div>
          <Title>シフト提出</Title>
          <p style={{ margin: 0, color: "#64748b", }}>希望シフトの提出と予定給与の確認ができます。</p>
        </div>
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <Button color="light" size="auto" onClick={() => setPage("attendance")}>出退勤画面</Button>
          <Button color="red" size="auto" onClick={handleLogout}>ログアウト</Button>
        </div>
      </div>
	      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(280px, 100%), 1fr))", gap: "18px", marginTop: "20px", alignItems: "start", }}>
	      <Card className="p-5">
	        <h2 style={{ margin: "0 0 14px", fontSize: "18px", fontWeight: 800, }}>シフト提出</h2>
	        <label style={{ fontSize: "13px", fontWeight: 700, color: "#334155", }}>
	          日付
	          <Input size = "sm" type="date" value={date} onChange={(e) => setDate(e.target.value)}/>
	        </label>
	        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(140px, 100%), 1fr))", gap: "10px", }}>
	          <label style={{ fontSize: "13px", fontWeight: 700, color: "#334155", }}>
	            開始
	            <Input size = "sm" type="time" step="1800" value={startTime} onChange={(e) => setStartTime(e.target.value)}/>
	          </label>
	          <label style={{ fontSize: "13px", fontWeight: 700, color: "#334155", }}>
	            終了
	            <Input size = "sm"type="time" step="1800" value={endTime} onChange={(e) => setEndTime(e.target.value)}/>
	          </label>
	        </div>
	        <Button color="green" size="full" onClick={handleSubmit}>提出</Button>
	      </Card>
	      <Card className="p-5">
	        <p style={{ margin: 0, color: "#64748b", fontSize: "13px", fontWeight: 700 }}>予定給与</p>
	        <h2 style={{ margin: "4px 0 0", fontSize: "30px", fontWeight: 800, color: "#111827", }}>¥{Math.floor(calculateSalary()).toLocaleString()}</h2>
	        <p style={{ margin: "8px 0 18px", color: "#64748b", fontSize: "13px", }}>深夜・残業・交通費上限込み</p>
          <label style={{ fontSize: "13px", fontWeight: 700, color: "#334155", }}>
            表示月
            <Input size = "sm" type="month" value={shiftMonth} onChange={(e) => setShiftMonth(e.target.value)} />
          </label>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(120px, 100%), 1fr))", gap: "10px", marginTop: "4px" }}>
            <div style={{ background: "#f0fdf4", color: "#166534", borderRadius: "8px", padding: "10px" }}>
              <p style={{ margin: 0, fontSize: "12px", fontWeight: 700 }}>確定</p>
              <strong>{approvedShifts.length}件</strong>
            </div>
            <div style={{ background: "#fffbeb", color: "#92400e", borderRadius: "8px", padding: "10px" }}>
              <p style={{ margin: 0, fontSize: "12px", fontWeight: 700 }}>未確定</p>
              <strong>{pendingShifts.length}件</strong>
            </div>
          </div>
	      </Card>
	      </div>
	      <h2 style={{ margin: "22px 0 12px", fontSize: "20px", fontWeight: 800, }}>確定シフト</h2>

	    {approvedShifts.length === 0 ? (
        <Card><p style={{ margin: 0, color: "#64748b" }}>この月の確定シフトはありません</p></Card>
      ) : approvedShifts.map((shift) => (
	      <Card key={shift.id} className="p-4">
	        <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "center", flexWrap: "wrap", }}>
	          <div>
	            <p style={{ margin: 0, color: "#64748b", fontSize: "13px", }}>{formatInputDateToJapanese(shift.date)}</p>
	            <h3 style={{ margin: "4px 0 0", fontSize: "22px", fontWeight: 800, }}>{shift.start_time}〜{shift.end_time}</h3>
	          </div>
	          <span style={{ background: "#dcfce7", color: "#166534", borderRadius: "999px", padding: "5px 10px", fontSize: "12px", fontWeight: 800, }}>確定</span>
	        </div>
	      </Card>
	    ))}

	    <h2 style={{ margin: "22px 0 12px", fontSize: "20px", fontWeight: 800, }}>未確定シフト</h2>
	    {pendingShifts.length === 0 ? (
        <Card><p style={{ margin: 0, color: "#64748b" }}>この月の未確定シフトはありません</p></Card>
      ) : pendingShifts.map((shift) => (
	      <Card key={shift.id} className="p-4">
	        {editId === shift.id ? (
	          <>
	            <Input size = "sm" type="date" value={shift.date} onChange={(e) => {
	                const updated = shifts.map((s) =>
	                  s.id === shift.id? {...s,date: e.target.value,}: s
	                );
                setShifts(updated);
              }}/>

	            <Input size = "sm" type="time" value={shift.start_time} onChange={(e) => {
	                const updated = shifts.map((s) =>
	                  s.id === shift.id? {...s,start_time:e.target.value,}: s
	                );
                setShifts(updated);
              }}/>
            <Input size = "sm" type="time" value={shift.end_time} onChange={(e) => {
                const updated = shifts.map((s) =>
                  s.id === shift.id? {...s,end_time:e.target.value,}: s
                );
                setShifts(updated);
              }}/>
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
	              <Button color="green" size="auto" onClick={() =>handleUpdate(shift)}>保存</Button>
                <Button color="light" size="auto" onClick={() => setEditId(null)}>キャンセル</Button>
              </div>
	          </>
	        ) : (
	          <>
	            <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "center", flexWrap: "wrap", }}>
	              <div>
	                <p style={{ margin: 0, color: "#64748b", fontSize: "13px", }}>{formatInputDateToJapanese(shift.date)}</p>
	                <h3 style={{ margin: "4px 0 0", fontSize: "22px", fontWeight: 800, }}>{shift.start_time}〜{shift.end_time}</h3>
	              </div>
	              <span style={{ background: "#fef3c7", color: "#92400e", borderRadius: "999px", padding: "5px 10px", fontSize: "12px", fontWeight: 800, }}>未確定</span>
	            </div>
	            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginTop: "12px", }}>
	              <Button color="blue" size="auto" onClick={() => setEditId(shift.id)}>編集</Button>
	              <Button color="red" size="auto" onClick={() =>handleDelete(shift.id)}>削除</Button>
	            </div>
	          </>
	        )}
	      </Card>
	    ))}
	      </main>
	  </div>
	);}
export default StaffShift;
